{
  "title": "ЧАРХИ ШОНС",
  "description": "Ҳар рӯз шонси худро озмо!",
  "available": "Имконияти ройгони имрӯза тайёр аст!",
  "spin": "🎡 ЧАРХ ЗАН",
  "spinning": "Чарх мечархад...",
  "winTitle": "Табрик!",
  "win": "Шумо {{amount}} AZN бонус бурд кардед!",
  "used": "🎁 Шонси имрӯзаро истифода кардед! Пагоҳ боз биёед!",
  "homeCta": "Чархро зер кунед ва шонси худро озмоед",
  "homeUsed": "Пагоҳ боз биёед!",
  "ribbonReady": "ШОНСАТРО ОЗМО",
  "ribbonUsed": "ПАГОҲ БОЗ БИЁ",
  "hubSpin": "ЧАРХ ЗАН",
  "sheetHint": "Чархро зер кунед ва шонси худро озмоед",
  "winAmount": "{{amount}} AZN БУРД КАРДЕД!",
  "closeResult": "Пӯшидан",
  "demoBadge": "Намоиши визуалӣ — бонуси воқеӣ ҳанӯз фаъол нест",
  "demoWinNote": "Ин танҳо натиҷаи визуалӣ аст. Ба баланси бонус кредит дода нашуд.",
  "testBadge": "ТЕСТИ СОМОНА — TEST BONUS, гирифта намешавад",
  "testWinNote": "{{amount}} AZN TEST BONUS кредит шуд. Ин маблағ гирифта намешавад ва ба баланси воқеӣ илова намегардад.",
  "testBalance": "Бонуси тест",
  "testLedger": "TEST BONUS (гирифта намешавад)",
  "testNotWithdrawable": "Маблағи тестро гирифтан мумкин нест",
  "testExpires": "Муҳлати тест: {{when}}",
  "testPrize": "Ҷоизаи тест: {{amount}} AZN",
  "mute": "Хомӯш кардани садо",
  "unmute": "Фаъол кардани садо",
  "close": "Пӯшидан",
  "openAria": "Чархи шонси VBB-ро кушоед",
  "spinFailed": "Чархзанӣ оғоз нашуд. Лутфан каме баъд аз нав кӯшиш кунед.",
  "wageringTitle": "Талаботи бонус",
  "bonusBalance": "Баланси бонус",
  "wageringMultiplier": "Талаб",
  "wageringMultiplierValue": "{{count}}x",
  "wageringTarget": "Ҳадафи шарт",
  "wageringCompleted": "Иҷро шуд",
  "wageringRemaining": "Боқӣ монд",
  "bonusStatus": "Ҳолати бонус",
  "withdrawalEligibility": "Гирифтан",
  "bonusNotWithdrawable": "Бонус то тасдиқи табдил гирифта намешавад",
  "loginRequiredBadge": "Login required for real bonus",
  "loginRequired": "Please sign in."
}
